const contextMenu = {
  colors: "צבעים",
  backgroundColor: "רקע",
  textColor: "טקסט",
  textHighlight: "הדגשה",
  borderColor: "גבול",
  typography: "טיפוגרפיה",
  fontFamily: "גופן",
  fontSize: "גודל",
  letterSpacing: "ריווח אותיות",
  lineHeight: "גובה שורה",
  textContent: "תוכן טקסט",
  resetElement: "אפס רכיב",
  resetAll: "אפס הכל",
  openPicker: "פתח בוחר צבע",
  transparent: "שקוף",
  overridesSection: "עיצוב רכיבים",
  overridesHint: "לחץ ימני על כל רכיב להתאמה",
  systemDefault: "ברירת מחדל",
  myCustom: "מותאם אישית",
  nameHistory: "היסטוריית שמות",
  noHistory: "אין היסטוריה",
  originalName: "שם מקורי",
  restoreName: "שחזר שם",
} as const;
export default contextMenu;
